import React from 'react';
import { Button, CircularProgress } from '@mui/material';

const CTAButton = ({ 
  children, 
  variant = 'primary', 
  size = 'large',
  loading = false,
  sx = {},
  ...props 
}) => {
  const getButtonStyles = () => {
    const baseStyles = {
      py: { xs: 2, md: 2 },
      px: { xs: 4, md: 4 },
      fontSize: { xs: '1.1rem', md: '1.1rem' },
      textTransform: 'none',
      borderRadius: '50px',
      fontWeight: 600,
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)'
      }
    };

    switch (variant) {
      case 'primary':
        return {
          ...baseStyles,
          background: 'linear-gradient(135deg, #1976d2 0%, #1565C0 100%)',
          boxShadow: '0 8px 20px -6px rgba(25, 118, 210, 0.5)',
          '&:hover': {
            ...baseStyles['&:hover'],
            background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)',
            boxShadow: '0 12px 24px -8px rgba(25, 118, 210, 0.6)'
          }
        };
      case 'secondary':
        return {
          ...baseStyles,
          backgroundColor: '#ff9800',
          color: 'white',
          boxShadow: '0 8px 20px -6px rgba(255, 152, 0, 0.5)',
          '&:hover': {
            ...baseStyles['&:hover'],
            backgroundColor: '#f57c00',
            boxShadow: '0 12px 24px -8px rgba(255, 152, 0, 0.6)'
          }
        };
      case 'outline':
        return {
          ...baseStyles,
          borderColor: '#1976d2',
          color: '#1976d2',
          '&:hover': {
            ...baseStyles['&:hover'],
            backgroundColor: 'rgba(25, 118, 210, 0.04)',
            borderColor: '#1565C0'
          }
        };
      case 'navbar':
        return {
          px: { xs: 2, md: 3 },
          py: { xs: 0.5, md: 1 },
          fontSize: { xs: '0.875rem', md: '0.95rem' },
          fontWeight: 500,
          whiteSpace: 'nowrap',
          textTransform: 'none',
          background: 'linear-gradient(135deg, #1976d2 0%, #1565C0 100%)',
          boxShadow: '0 4px 14px 0 rgba(25, 118, 210, 0.3)',
          borderRadius: '50px',
          '&:hover': {
            background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)',
            boxShadow: '0 6px 20px 0 rgba(25, 118, 210, 0.4)',
            transform: 'translateY(-2px)'
          },
          transition: 'all 0.3s ease'
        };
      default:
        return baseStyles;
    }
  };

  const buttonVariant = variant === 'outline' ? 'outlined' : 'contained';

  return (
    <Button
      variant={buttonVariant}
      size={size}
      disabled={loading}
      sx={{ ...getButtonStyles(), ...sx }}
      {...props}
    >
      {loading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        children
      )}
    </Button>
  );
};

export default CTAButton; 